const ResultSet = class {
  constructor({ success = true, code = 200, errorCode = '400', result = null, message, status }) {
    this.success = success
    this.code = code
    this.errorCode = errorCode
    this.result = result
    this.message = message
    this.status = status
  }

  get failed() {
    return !this.success
  }

  static ok({ result, message }) {
    return new ResultSet({ result, message })
  }

  static fail({ message = '진행 중 문제가 발생했습니다.', errorCode, result }) {
    const [ main, sub ] = errorCode.split('.')
    return new ResultSet({ success: false, message, code: main, status: sub, result })
  }
}

export default ResultSet
